export function createDedupTracker() {
  const map = new Map<string, number>();

  return {
    isDuplicate(key: string): boolean {
      // In-memory dedup — skip if same key processed within 5s
      // (prevents race conditions during subscription transitions)
      const now = Date.now();
      const last = map.get(key);
      if (last && now - last < 5000) return true;
      map.set(key, now);
      setTimeout(() => {
        if (map.get(key) === now) {
          map.delete(key);
        }
      }, 5000);
      return false;
    },
  };
}
